import { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./Aluno.module.css"
import Alerta from "../../components/alerta/Alerta";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import { Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdDelete, MdEdit, MdSearch, MdClose } from "react-icons/md";
import AlunoApi from "../../services/AlunoApi";
import Paginacao from "../../components/paginacao/Paginacao";
import UsuarioApi from "../../services/UsuarioApi";
import { MdAssessment } from "react-icons/md";
import InputMask from "react-input-mask";
import BotaoComLoading from "../../components/loadingBotoes/LoadingBotoes";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Aluno() {
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    //Modais para editar e excluir
    const [mostrarModalDeletar, setMostrarModalDeletar] = useState(false);
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");

    //Para rodar a tabela, paginação e filtro
    const [usuarios, setUsuarios] = useState([]);
    const [quantidadeItens, setQuantidadeItens] = useState(0);
    const [usuariosComTurmaMonitor, SetUsuariosComTurmaMonitor] = useState([]);
    const [quantidadeItensComTurmaMonitor, SetQuantidadeItensComTurmaMonitor] = useState(0);
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [nomeFiltro, setNomeFiltro] = useState("");
    const [emailFiltro, setEmailFiltro] = useState("");
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [tamanhoPagina, setTamanhoPagina] = useState(10);
    const [tipoConsulta, setTipoConsulta] = useState("COM_TURMA");

    //Para modal de editar
    const [nomeNovo, setNomeNovo] = useState("");
    const [nomeContatoNovo, setNomeContatoNovo] = useState("");
    const [cpfNovo, setCpfNovo] = useState(null)
    const [rgNovo, setRgNovo] = useState(null)
    const [statusNovo, setStatusNovo] = useState(null)
    const [dataDeNascimentoNovo, setDataDeNascimentoNovo] = useState(null);
    const [alunoId, setAlunoId] = useState(null);
    const [statusUsuarios, setStatusUsuarios] = useState([]);

    const [loading, setLoading] = useState(false);

    //Função para filtro de busca
    async function BuscarUsuarios() {
        setNome(nomeFiltro);
        setEmail(emailFiltro);
        setPaginaAtual(1);
        //await CarregarUsuarios();
        await CarregarUsuariosComTurmaMonitor();
    }

    //Função para resetar  filtro de busca
    async function ResetarUsuarios() {
        setNome("");
        setEmail("");
        setNomeFiltro("");
        setEmailFiltro("");
        setPaginaAtual(1);
        //await CarregarUsuarios();
        //await CarregarUsuariosComTurmaMonitor();
        await CarregarUsuariosComOuSemTurmaMonitor();
    }

    //Função para alterar a página
    async function AlterarPagina(paginaNova) {
        setPaginaAtual(paginaNova);
        //await CarregarUsuarios();
        //await CarregarUsuariosComTurmaMonitor();
        await CarregarUsuariosComOuSemTurmaMonitor();
    }

    //Função para abrir o modal de editar
    const AbrirModalEditar = async (usuario) => {
        const usuarioEditar = await AlunoApi.ObterAlunoPorPessoaId(usuario.pessoaID);

        setUsuarioSelecionado(usuario);
        setNomeNovo(usuarioEditar.nomeCompleto);
        setNomeContatoNovo(usuarioEditar.nomeContato);
        setCpfNovo(usuarioEditar.cpf);
        setRgNovo(usuarioEditar.rg);
        setStatusNovo(usuario.status);
        setAlunoId(usuario.pessoaID);
        setDataDeNascimentoNovo(usuarioEditar.dataDeNascimento);
        setMostrarModalEditar(true);
    };


    //Função para abrir o modal de deletar
    const AbrirModalDeletar = (usuario) => {
        setUsuarioSelecionado(usuario);
        setMostrarModalDeletar(true);
    };

    //Função para editar Usuarios
    const BotaoEditar = async () => {
        try {
            setLoading(true);
            await AlunoApi.editarAlunoAsync(usuarioSelecionado.pessoaID, nomeNovo, nomeContatoNovo, cpfNovo, rgNovo, dataDeNascimentoNovo, statusNovo);

            //CarregarUsuarios();
            //CarregarUsuariosComTurmaMonitor();
            await CarregarUsuariosComOuSemTurmaMonitor();
            setMensagemAlerta(`Usuário atualizado com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);

        } catch (error) {
            setMensagemAlerta(`Erro ao atualizar usuário: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            FecharModal();
            setLoading(false);

        }
    };

    //Função para deletar usuarios
    const BotaoDeletar = async () => {
        try {
            setLoading(true);
            await AlunoApi.deletarAlunoAsync(usuarioSelecionado.pessoaID);
            SetUsuariosComTurmaMonitor(usuariosComTurmaMonitor.filter((u) => u.pessoaID !== usuarioSelecionado.pessoaID));
            setMensagemAlerta(`Usuário deletado com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao deletar usuário: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            FecharModal();
            setLoading(false);
        }
    };

    //Função para o fechar modal
    const FecharModal = () => {
        setMostrarModalDeletar(false);
        setMostrarModalEditar(false);
        setUsuarioSelecionado(null);
    };

    const handleChangeTamanhoPagina = (e) => {
        setTamanhoPagina(Number(e.target.value));
        setPaginaAtual(1);
    };

    //Função para carregar os usuarios
    async function CarregarUsuarios() {
        try {


            const listaUsuarios = await AlunoApi.listarAlunosAsync(paginaAtual, nome, email);


            setQuantidadeItens(listaUsuarios.quantidadeRegistros);
            setUsuarios(listaUsuarios.registros);
        } catch (error) {
            console.error("Erro ao carregar usuários:", error.response.data);
        }
    }

    //Função para carregar somente alunos do qual o usuário é monitor
    async function CarregarUsuariosComTurmaMonitor() {
        try {
            const listaUsuarios = await AlunoApi.ListarAlunosComTurmaMonitor(paginaAtual, tamanhoPagina, nome, email);

            SetQuantidadeItensComTurmaMonitor(listaUsuarios.quantidadeRegistros);
            SetUsuariosComTurmaMonitor(listaUsuarios.registros);
        } catch (error) {
            console.error("Erro ao carregar usuários com turma:", error.response.data);
        }
    }

    //Função para carregar somente alunos do qual o usuário é monitor ou usuários sem turma ou sem monitor
    async function CarregarUsuariosComOuSemTurmaMonitor() {
        try {
            const listaUsuarios = await AlunoApi.ListarAlunosComOuSemTurmaMonitor(paginaAtual, tamanhoPagina, nome, email, tipoConsulta);

            SetQuantidadeItensComTurmaMonitor(listaUsuarios.quantidadeRegistros);
            SetUsuariosComTurmaMonitor(listaUsuarios.registros);
        } catch (error) {
            console.error("Erro ao carregar usuários com ou sem turma:", error.response.data);
        }
    }

    //Função para o modal de Editar
    async function BuscarStatusUsuarios() {
        try {
            const status = await UsuarioApi.listarStatusUsuarioAsync();
            setStatusUsuarios(status);
        } catch (error) {
            console.error("Erro ao buscar status do usuário:", error.response.data);
        }
    }

    const totalPaginas = Math.ceil(quantidadeItensComTurmaMonitor / tamanhoPagina); //total de paginas com itens filtrados

    //Função para exibir o alerta
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    useEffect(() => {
        //CarregarUsuarios();
        //CarregarUsuariosComTurmaMonitor();
        CarregarUsuariosComOuSemTurmaMonitor();
        BuscarStatusUsuarios();
    }, []);

    useEffect(() => {
        //CarregarUsuarios();
        //CarregarUsuariosComTurmaMonitor();
        CarregarUsuariosComOuSemTurmaMonitor();
    }, [paginaAtual, nome, email, tipoConsulta, tamanhoPagina]);

    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>


                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />


                {loading && <Loader />}
                <div className={style.pagina_conteudo}>
                    {/* Cabeçalho da pagina */}
                    <div className={style.container_cabecalho}>
                        <h4>Alunos</h4>
                    </div>

                    {/* Filtro de pesquisa */}
                    <div className={style.container_filtro}>
                        <div className={style.container_filtro_esquerda}>
                            <InputBuscar
                                type="text"
                                id="hidenNome"
                                className={style.input_filtro}
                                placeholder="Nome"
                                name="nome"
                                value={nomeFiltro}
                                maxLength={30}
                                onChange={(e) => setNomeFiltro(e.target.value)}
                            />

                            <InputBuscar
                                type="text"
                                id="hidenEmail"
                                className={style.input_filtro}
                                placeholder="Email"
                                name="email"
                                value={emailFiltro}
                                maxLength={50}
                                onChange={(e) => setEmailFiltro(e.target.value)}
                            />
                            <Button onClick={BuscarUsuarios} id={style.botao_buscar}><MdSearch /> Buscar
                            </Button>

                            <Button onClick={ResetarUsuarios} id={style.botao_resetar}><MdClose /> Limpar
                            </Button>
                        </div>

                        <div className={style.container_tipo_consulta}>
                            <Form.Select
                                value={tipoConsulta}
                                onChange={(e) => setTipoConsulta(e.target.value)}
                                title={tipoConsulta === "COM_TURMA"
                                    ? "Meus alunos"
                                    : "Alunos sem monitor"
                                }
                            >
                                <option value="COM_TURMA">Meus alunos</option>
                                <option value="SEM_TURMA">Alunos sem monitor</option>
                            </Form.Select>
                        </div>

                    </div>

                    {/* Tabela com paginação */}
                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Email</th>
                                        <th>Turma</th>
                                        <th>Último login</th>
                                        <th>Status</th>
                                        <th className={style.coluna_acoes}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usuariosComTurmaMonitor.map((usuario) => (
                                        <tr className={style.tabela_corpo} key={usuario.pessoaID}>
                                            <td title={usuario.nomeCompleto}>{usuario.nomeCompleto}</td>
                                            <td title={usuario.email}>{usuario.email}</td>
                                            <td title={usuario.turma}>{usuario.turma ? usuario.turma : "Sem turma"}</td>
                                            <td title={usuario.dataUltimoLogin}>{new Date(usuario.dataUltimoLogin).toLocaleDateString('pt-BR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}{' '}
                                                {new Date(usuario.dataUltimoLogin).toLocaleTimeString('pt-BR', {
                                                    hour: '2-digit',
                                                    minute: '2-digit'
                                                })}
                                            </td>
                                            <td title={statusUsuarios.find(s => s.id === usuario.status)?.nome}>{statusUsuarios.find(s => s.id === usuario.status)?.nome}</td>
                                            <td className={style.coluna_acoes}>
                                                <Link
                                                    to="/avaliacoes/aluno"
                                                    state={usuario.pessoaID}
                                                    className={style.botao_editar}
                                                >
                                                    <MdAssessment
                                                        title="Avaliações" />
                                                </Link>
                                                <Link
                                                    onClick={() => AbrirModalEditar(usuario)}
                                                    className={style.botao_editar}
                                                >
                                                    <MdEdit
                                                        title="Editar" />
                                                </Link>
                                                <Link
                                                    onClick={() => AbrirModalDeletar(usuario)}
                                                    className={style.botao_deletar}
                                                >
                                                    <MdDelete
                                                        title="Deletar" />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* Controle de Paginação */}
                        <div className={style.container_navegacao_paginacao}>
                            <Paginacao
                                paginaAtual={paginaAtual}
                                totalPages={totalPaginas}
                                onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
                            />

                            <div className={style.paginacao_itens}>
                                <Form.Label className="mb-0">Itens por página</Form.Label>
                                <Form.Select
                                    value={tamanhoPagina}
                                    onChange={handleChangeTamanhoPagina}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                </Form.Select>
                            </div>
                        </div>

                    </div>
                    {/* Modal de confirmação */}
                    <Modal show={mostrarModalDeletar} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            Tem certeza que deseja deletar o usuário{" "}
                            {usuarioSelecionado?.nomeCompleto}?
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary " onClick={FecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="danger" onClick={BotaoDeletar}>
                                Deletar
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal de confirmação */}
                    <Modal show={mostrarModalEditar} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Editar Aluno</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form.Group controlId="nome" className="mb-3">
                                <Form.Label>Nome Completo</Form.Label>
                                <InputBuscar
                                    maxLength={100}
                                    type="text"
                                    placeholder="Nome completo"
                                    value={nomeNovo}
                                    onChange={(e) => setNomeNovo(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group controlId="cpf" className="mb-3">
                                <Form.Label>CPF</Form.Label>
                                <InputMask
                                    id={style.desabilitar}
                                    mask="999.999.999-99"
                                    value={cpfNovo}
                                    readOnly
                                >
                                    {(inputProps) => (
                                        <Form.Control
                                            {...inputProps}
                                            type="text"
                                            placeholder="CPF"
                                        />
                                    )}
                                </InputMask>
                            </Form.Group>

                            <Form.Group controlId="rg" className="mb-3">
                                <Form.Label>RG</Form.Label>
                                <InputMask
                                    id={style.desabilitar}
                                    mask="99.999.999-9"
                                    placeholder="RG"
                                    value={rgNovo}
                                    onChange={(e) => setRgNovo(e.target.value)}
                                >
                                    {(inputProps) => (
                                        <Form.Control
                                            {...inputProps}
                                            type="text"
                                            placeholder="RG"
                                        />
                                    )}
                                </InputMask>
                            </Form.Group>


                            <Form.Group controlId="dataNascimento" className="mb-3">
                                <Form.Label>Data de Nascimento</Form.Label>
                                <InputBuscar
                                    min="1900-01-01"
                                    max="2099-12-31"
                                    type="date"
                                    value={dataDeNascimentoNovo}
                                    onChange={(e) => setDataDeNascimentoNovo(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group controlId="formStatusUsuario" className="mb-3">
                                <Form.Label>Status do Usuário</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="statusUsuario"
                                    value={statusNovo}
                                    onChange={(e) => setStatusNovo(e.target.value)}
                                    required
                                >
                                    {statusUsuarios.map((statusUsuario) => (
                                        <option key={statusUsuario.id} value={statusUsuario.id}>
                                            {statusUsuario.nome}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary " onClick={FecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={BotaoEditar}>
                                Atualizar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </Topbar >
        </Sidebar>
    );
}

export default Aluno;